import store from '../../store.js';

export const fetchProfile = ()=>{
    return store.getState().ims.userProfile ;
}